import React from "react";
import Yuki from "./Yuki";
import Don from "./Don";
import Cylvia from "./Cylvia";
import Yuhwan from "./Yuhwan";

const TestComponents = () => {
  return (
    <div>
      <Yuki />
      <Don />
      <Cylvia />
      <Yuhwan />
    </div>
  );
};

export default TestComponents;
